
<template>
    <el-tree-select class="x-tree-select" :multiple="config.selectType == SelectType.MULTIPLE_SELECT" :disabled="config.readonly" :model-value="modelValue" :data="getTreeData(config.nameField, config.keyField, config.parentKeyField)"
        @update:modelValue="(value, oldvalue)=>$emit('update:modelValue', value, oldvalue)" :clearable="true" :render-after-expand="true"
        :readonly="config.readonly" :placeholder="config.placeholder"
    >
    </el-tree-select>
</template>
<script setup>
import SelectType from "../data/SelectType";
import { getOptions, mergeFilter } from '../utils.js';

const props = defineProps({
    config: { default: null },
    readonly: { default: false },
    modelValue: { default: null },
    data: { default: null },
    field: { default: null },
});

defineEmits({
    "update:modelValue": null,
});

const getTreeData = (nameField, keyField, parentKeyField)=> {
    const datas = getOptions(props.config.dataOptions, mergeFilter(props.config.localFilter, props.config.pathFilter), props.data);
    return datas;
}

</script>
<style>

</style>